import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

/** Tipos de diálogo: definen icono y tono de cabecera. */
export type DsDialogType = "confirm" | "info" | "danger" | "success";

export interface DsConfirmData {
	type?: DsDialogType;
	/** Texto ya traducido. */
	title: string;
	subtitle?: string;
	message?: string;
	confirmText?: string;
	cancelText?: string;
	/** Color del botón de confirmar. */
	confirmTone?: "primary" | "danger";
	/** Icono mat-icon explícito (si no, se deriva del tipo). */
	icon?: string;
	/** Oculta el botón de cancelar (diálogo meramente informativo). */
	hideCancel?: boolean;
}

/**
 * Diálogo de confirmación/aviso del design-system. Cabecera común (icono por tipo +
 * título/subtítulo), cuerpo y pie con botones del sistema (positivo/negativo).
 * Se abre vía DialogService.confirm(). Devuelve true (confirmar) / false (cancelar).
 */
@Component({
	selector: "app-ds-confirm-dialog",
	templateUrl: "./ds-confirm-dialog.component.html",
	standalone: false,
})
export class DsConfirmDialogComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: DsConfirmData,
		public dialogRef: MatDialogRef<DsConfirmDialogComponent, boolean>,
	) {}

	get icon(): string {
		if (this.data.icon) {
			return this.data.icon;
		}
		switch (this.data.type) {
			case "danger":
				return "warning_amber";
			case "success":
				return "check_circle";
			case "info":
				return "info";
			default:
				return "help_outline";
		}
	}
}
